document.addEventListener('DOMContentLoaded', () => {
  const mobileButton = document.querySelector('[data-menu-toggle]');
  const mainNav = document.querySelector('[data-main-nav]');

  if (mobileButton && mainNav) {
    mobileButton.addEventListener('click', () => {
      const open = mainNav.classList.toggle('is-open');
      mobileButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const closeTopMenus = (except) => {
    document.querySelectorAll('.nav-item.has-children.is-open').forEach((item) => {
      if (item !== except) {
        item.classList.remove('is-open');
        const btn = item.querySelector(':scope > [data-submenu-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  };

  document.querySelectorAll('[data-submenu-toggle]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const item = button.closest('.nav-item.has-children');
      const willOpen = !item.classList.contains('is-open');
      closeTopMenus(item);
      item.classList.toggle('is-open', willOpen);
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-child-toggle]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const item = button.closest('.nav-dropdown__item.has-grandchildren');
      const willOpen = !item.classList.contains('child-open');
      item.classList.toggle('child-open', willOpen);
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.nav--main')) closeTopMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeTopMenus();
  });
});

// Threadgill's mobile product gallery: tap a thumbnail to update the main image.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const mainImage = gallery.querySelector('.product-gallery__featured img');
    const thumbs = gallery.querySelectorAll('[data-product-thumb]');

    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const nextSrc = thumb.dataset.imageSrc;
        const nextAlt = thumb.dataset.imageAlt || mainImage.alt;

        if (!nextSrc) return;

        mainImage.src = nextSrc;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.alt = nextAlt;

        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  });
});
